import { updateOfficeOrigin } from "../../../../../actions/Utilities/OfficeOrigin";
import { useMutation } from "react-query";

const useUpdateOfficeOrigin = () => {
  return useMutation(updateOfficeOrigin);
};
export default useUpdateOfficeOrigin;
